import styled from "styled-components"
import ButtonLink from "../btn-collections/btn-collections.component"
import Chevron from "../../svg/career-path-button-chevron-white.svg"
import ChevronBlue from "../../svg/career-path-button-chevron-blue.svg"

export const DefaultIcon = styled.span`
    display: block;
    margin-top: 2px;
`

export const HoverIcon = styled.span`
    display: none;
    margin-top: 2px;
`

export const WhiteChevron = styled(Chevron)`
    display: block;
    margin-left: 10px;
`

export const BlueChevron = styled(ChevronBlue)`
    display: none;
    margin-left: 10px;
`

export const CareerPathButtonContainer = styled(ButtonLink)`
  height: 70px;
  display: flex;
  flex-direction: row;
  background-color: transparent;
  border: 2px solid white;
  align-items: center;
  justify-content: center;
  border-radius: 70px;
  padding: 0 40px 0 25px;
  cursor: pointer;

  @media only screen and (max-width: 620px) {
    width: 100%;
    justify-content: space-between;
    padding: 0 25px 0 25px;
  }
  
  &:focus-visible {
    outline: 4px solid white;
    border-color: transparent;
  }

  &:hover, &:active, &.active {
    background-color: #9BF9FF;
    border: 2px solid #9BF9FF;

    ${DefaultIcon} { display: none; }
    ${HoverIcon} { display: block; }
    ${WhiteChevron} { display: none; }
    ${BlueChevron} { display: block; }
  
    div {
      color: #4c0ffb;
    }
  }
`

export const CareerPathButtonText = styled.div`
  font-family: Barlow, sans-serif;
  text-transform: uppercase;
  font-size: 20px;
  color: white;
  font-weight: 600;
  margin-left: 10px;

   @media only screen and (max-width: 620px) {
    width: 100%;
    justify-content: space-between;
  }
`